import { api, setApiToken } from '@/api';
import { advertisings } from '@/store/advertisings';
import { categories } from '@/store/categories';
import { records } from '@/store/records';
import { settings } from '@/store/settings';
import { templates } from '@/store/templates';
import { videos } from '@/store/videos';
import Vue from 'vue';
import Vuex, { ActionContext } from 'vuex';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

export type RootState = {
    token: string | null;
};

const vuexLocal = new VuexPersistence<RootState>({
    storage: window.localStorage,
    modules: ['token', 'categories', 'templates', 'videos', 'records', 'advertisings', 'settings'],
    restoreState: (key, storage) => {
        const data = storage?.getItem(key);
        const state: RootState = data ? JSON.parse(data) : { token: null };

        if (state.token !== null) {
            setApiToken(state.token);
        }

        return state;
    },
});

export default new Vuex.Store<RootState>({
    state: {
        token: null,
    },
    mutations: {
        setToken(state: RootState, token: string | null) {
            state.token = token;
            token && setApiToken(token);
        },
    },
    getters: {
        token: (state) => state.token,
        isLoggedIn: (state) => state.token !== null,
    },
    actions: {
        async login(context: ActionContext<RootState, any>, payload) {
            const response = await api.post('/auth', payload);

            if (!response || !response.data || !response.data.token) {
                throw new Error('Invalid credentials');
            }

            context.commit('setToken', response.data.token);
        },
        logout(context: ActionContext<RootState, any>) {
            context.commit('setToken', null);
        },
    },
    modules: {
        advertisings,
        categories,
        records,
        settings,
        templates,
        videos,
    },
    strict: process.env.NODE_ENV !== 'production',
    plugins: [vuexLocal.plugin],
});
